import { SocialProfiles } from './Settings';
import {
  AllowanceCycle,
  AllowanceType,
  MemberRole,
  MemberState,
  UserStatus,
} from './user';

export enum OptedWorkspaceExperience {
  Legacy = 'V2',
  New = 'V3',
}
export interface CurrentUserProfile {
  department: string;
  firstName: string;
  isManager: boolean;
  lastName: string;
  timezone: string;
  username: string;
  jobTitle: string;
  location: string;
  workLocation?: string;
  image: string;
  birthday: {
    day?: number;
    month?: number;
    isVisibleAndCelebrated?: boolean;
  };
  hiredday: {
    day?: number;
    month?: number;
    year?: number;
  };
  showQuickSetupPanel: boolean;
  showLeftDrawer: boolean;
  pronouns?: string;
  aboutMe?: string;
  socialProfiles?: SocialProfiles;
}

export interface CurrentUser {
  memberId: string;
  email: string;
  totalPointsEarned: number;
  pointsEarned: number;
  totalPointsGiven: number;
  pointsLeftThisCycle: number;
  pointsEarnedThisCycle: number;
  role: MemberRole[];
  status: UserStatus;
  profile: CurrentUserProfile;
  managerIds: string[];
  reportIds: string[];
  allowance: {
    points: number;
    type: AllowanceType;
    cycle: AllowanceCycle;
  };
  activatedAt: Date;
  isQuickSetupComplete: boolean;
  timeZone?: string;
  optedWorkspaceExperience?: OptedWorkspaceExperience;
  isFreeEmail?: boolean;
  state?: MemberState;
}
